<template>
  <div>
    <el-divider content-position="left">活动的基站定位</el-divider>
    <el-table :data="baseData" style="width: 100%">
      <el-table-column label="设备" prop="name"></el-table-column>
      <el-table-column label="网络类型" prop="rat" width="240"></el-table-column>
      <el-table-column label="MCC" prop="mcc">
        <template slot-scope="scope">
          <span>{{ scope.row.mcc || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="MNC" prop="mnc">
        <template slot-scope="scope">
          <span>{{ scope.row.mnc || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="位置信息">
        <template slot-scope="scope">
          <div v-if="scope.row.rat.indexOf('CDMA') != -1">
            <span>SID: {{ scope.row.sid || "--" }}</span>
            <span>NID: {{ scope.row.nid || "--" }}</span>
            <span>BID: {{ scope.row.bid || "--" }}</span>
          </div>
          <div v-else>
            <span>LAC: {{ scope.row.lac || "--" }}</span>
            <span>CID: {{ scope.row.cid || "--" }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="频点" prop="arfcn">
        <template slot-scope="scope">
          <span>{{ scope.row.arfcn || "--" }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-divider content-position="left">活动的卫星定位</el-divider>
    <el-table :data="satelliteData" style="width: 100%">
      <el-table-column label="已启用" prop="enabled">
        <template slot-scope="scope">
          {{ scope.row.enabled == '1' ? '开启' : '关闭' }}
        </template>
      </el-table-column>
      <el-table-column label="设备" prop="gps_device"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          {{ (loc.status !== 'V') ? '有效' : '无效' }}
        </template>
      </el-table-column>
      <el-table-column label="总星数(北斗/GPS/格洛纳斯/伽利略)">
        <template slot-scope="scope">
          {{ Number(loc.bd_sate_num) + Number(loc.gps_sate_num) + Number(loc.gl_sate_num) +
            Number(loc.other_sate_num) }}({{ loc.bd_sate_num + '/' + loc.gps_sate_num + '/' +
            loc.gl_sate_num + '/' + loc.other_sate_num }})
        </template>
      </el-table-column>
      <el-table-column label="有效星">
        <template slot-scope="scope">
          {{ loc.satellites_num }}
        </template>
      </el-table-column>
      <el-table-column label="卫星时间">
        <template slot-scope="scope">
          {{ loc.satellites_date + " " + loc.satellites_time }}
        </template>
      </el-table-column>
      <el-table-column label="纬度">
        <template slot-scope="scope">
          <span>{{ loc.latitude || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="经度">
        <template slot-scope="scope">
          <span>{{ loc.longitude || "--" }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="地图"></el-table-column> -->
    </el-table>
  </div>
</template>

<script>

export default {
  props: ["deviceDid", "deviceSn", "data"],
  data() {
    return {
      satelliteData: [],
      baseData: [],
      loc: {},
    };
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler: function (newV) {
        console.log(newV);
        this.satelliteData = this.data.satelliteData || [];
        this.baseData = this.data.baseData || [];
        this.loc = this.data.loc || {};
      }
    }
  },
};
</script>
<style scoped></style>